import { Get } from "../http/httpVerbs";

export const apiGetFranchise = async (communityId, franchiseId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/comunidades/${communityId}/franchises/${franchiseId}`;
    const response = await Get(url);
    return response;
  } catch (error) {
    console.error("Error fetching franchise details:", error);
    throw error;
  }
};
